import { render } from "./PushBatchView.vue?vue&type=template&id=0380d842&scoped=true"
import script from "./PushBatchView.vue?vue&type=script&lang=js"
export * from "./PushBatchView.vue?vue&type=script&lang=js"

import "./PushBatchView.vue?vue&type=style&index=0&id=0380d842&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0380d842"]])

export default __exports__